import { getKeyDownName } from '@/utils/event-kit';

const isMac = (ua: string) => {
    return /(macintosh)|(mac os x)/.test(ua);
};

const KEY_MAP = {
    mac: 'Meta',
    win: 'Control',
};

const getSystem = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    if (isMac(ua)) {
        return 'mac';
    }
    return 'win';
};

const system = getSystem();

export const checkScaleKeydown = () => {
    const key = getKeyDownName();
    return key === KEY_MAP[system];
};
